import React, { useEffect, useState } from "react";

import { CircularProgress, IconButton, Button } from "@mui/material";

import { Formik, Form, FieldArray } from "formik";
import * as yup from "yup";
import FormControl from "../../MUI_components/FormControl/fomikFormControl";

import Steper from "../../MUI_components/stepper";
import Supplier from "../../../Service/Suppliers/supplier.service";
import { openSnackbar } from "../../../Redux/Actions/snackbarActions";
import { useDispatch } from "react-redux";
import Loading from "../../MUI_components/loading";
import { Add, Remove } from "@mui/icons-material";
import ErrorMessage from "Components/MUI_components/ErrorMessage";
import { REACT_QUERY_KEYS } from "Components/Constants/ReactQueryKeys";
import { useQuery } from "react-query";

const AddSupplier = ({ setOpen, code, setSubmitted }) => {
  const dispatch = useDispatch();
  const [clickSave, setClickSave] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const initValue = {
    customCode: "",
    name: "",
    contactName: "",
    address1: "",
    address2: "",
    currency: "",
    country: "Sri Lanka",
    phone1: "",
    phone2: "",
    webSite: "",
    email: "",
    isActive: true,
    isVerified: false,
    passportNumber: "",
    nicNumber: "",
    supplierAddresses: [],
  }
  // useEffect(() => {
  //   const getSupplier = async () => {
  //     if (code) {
  //       try {
  //         let response = await Supplier.get(code);
  //         response = JSON.parse(
  //           JSON.stringify(response).replace(/:null/gi, ':""')
  //         );
  //         setInitValue(response);
  //       } catch (e) {
  //         dispatch(openSnackbar(true, "error", e));
  //       }
  //     } else {
  //       setInitValue({
         
  //       });
  //     }
  //     setIsLoaded(true);
  //   };
  //   getSupplier();
  // }, [code, dispatch]);

  const { isSuccess, isError, isLoading, data } = useQuery(
    [REACT_QUERY_KEYS.ADD_SUPPLIER, code],
    () => Supplier.get(code),
    {
      enabled: !!code,
      initialData: initValue
    }
  )

  if (isLoading) {
    return <Loading />
  }
  if (isError) {
    return <ErrorMessage />
  }

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  // validation Schema for first step
  const Validation = yup.object({
    name: yup.string().required("Name is a required field"),
    // nicNumber: yup.string().min(10).max(12),
    // passportNumber: yup.string().min(8).max(10),
    phone1: yup.string().required("Contact Number is a required field"),
    // phone1: yup.string().matches(phoneRegExp, "Phone number is not valid"),
    // phone2: yup.string().matches(phoneRegExp, "Phone number is not valid"),
    // email: yup.string().email(),
  });

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };



  const handleSubmit = async (values) => {
    setClickSave(true);
    try {
      if (code) await Supplier.edit(values, code);
      else await Supplier.create(values);
      setSubmitted((prev) => !prev);
      setOpen(false);
      dispatch(
        openSnackbar(
          true,
          "success",
          `Supplier ${code ? "updated" : "created"} successfully`
        )
      );
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
    setClickSave(false);
  };

  const getSteps = ["General Information", "Contact Information"];

  return (
    <>
     
        <Formik
          initialValues={data}
          enableReinitialize={true}
          validationSchema={Validation}
          onSubmit={async (values) => {
            if (activeStep === getSteps.length - 1) {
              await handleSubmit(values);
            } else handleNext();
          }}
        >
          {({ isValid, isSubmitting, values }) => (
            <Form autoComplete="off">
              <Steper
                getSteps={getSteps}
                StepContent={getStepContent}
                activeStep={activeStep}
              />
              <div className="row space-between mb">
                <Button
                  disabled={activeStep === 0 || isValid === false}
                  onClick={handleBack}
                >
                  Back
                </Button>

                <div style={{ display: "flex" }}>
                  {code && activeStep !== getSteps.length - 1 && (
                    <Button
                      disabled={clickSave ? true : false}
                      startIcon={
                        clickSave && (
                          <CircularProgress color="inherit" size={20} />
                        )
                      }
                      onClick={() => {
                        handleSubmit(values);
                      }}
                      variant="contained"
                      color="primary"
                      style={{ marginRight: 5 }}
                    >
                      {clickSave ? "Saving" : "Save"}
                    </Button>
                  )}
                  <Button
                    disabled={isSubmitting ? true : false}
                    startIcon={
                      isSubmitting && (
                        <CircularProgress color="inherit" size={20} />
                      )
                    }
                    variant="contained"
                    type="submit"
                    color="secondary"
                  >
                    {activeStep === getSteps.length - 1 ? "Complete" : "Next"}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
     
    </>
  );

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <>
            <div className="row">
              <div className="col-2">
                <FormControl control="input" name="customCode" label="Code" />
              </div>
              <div className="col-6">
                <FormControl
                  control="input"
                  name="name"
                  label="Supplier Name"
                />
              </div>
              <div className="col-4">
                <FormControl
                  control="input"
                  label="Contact Number"
                  name="phone1"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <FormControl
                  control="input"
                  label="Street"
                  name="address1"
                  multiline
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <FormControl
                  control="input"
                  label="City"
                  name="address2"
                  multiline
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <FormControl
                  control="input"
                  name="passportNumber"
                  label="Passport Number"
                />
              </div>
              <div className="col-4">
                <FormControl control="input" name="country" label="Country" />
              </div>
              <div className="col-4">
                <FormControl control="input" label="Currency" name="currency" />
              </div>
            </div>

            <div className="row">
              {code && (
                <FormControl control="switch" name="isActive" label="Active" />
              )}
              <FormControl
                control="switch"
                name="isVerified"
                label="Verified"
              />
            </div>
          </>
        );
      case 1:
        return (
          <div>
            <div className="row">
              <div className="col-6">
                <FormControl
                  control="input"
                  label="Contact Person Name"
                  name="contactName"
                />
              </div>
              <div className="col-6">
                <FormControl control="input" label="Email" name="email" />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
              <FormControl
                  control="input"
                  label="NIC Number"
                  name="nicNumber"
                />
              </div>
              <div className="col-4">
                <FormControl
                  control="input"
                  label="Contact Number"
                  name="phone2"
                />
              </div>
              <div className="col-4">
                <FormControl control="input" label="Website" name="webSite" />
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <>
            <FieldArray name="supplierAddresses">
              {(addressProps) => {
                const { push, remove, form } = addressProps;
                const { values } = form;
                const { supplierAddresses } = values;

                return (
                  <div>
                    {supplierAddresses.map((element, index) => (
                      <div key={index}>
                        <div className="row flex-end">
                          <IconButton
                            onClick={() => remove(index)}
                            color="primary"
                          >
                            <Remove />
                          </IconButton>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <FormControl
                              control="input"
                              label="First Name"
                              name={`supplierAddresses[${index}].firstName`}
                            />
                          </div>
                          <div className="col-6">
                            <FormControl
                              control="input"
                              name={`supplierAddresses[${index}].secondName`}
                              label="Last Name"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4">
                            <FormControl
                              control="input"
                              label="Contact Number"
                              name={`supplierAddresses[${index}].phone1`}
                            />
                          </div>
                          <div className="col-4">
                            <FormControl
                              control="input"
                              label="Contact Number"
                              name={`supplierAddresses[${index}].phone2`}
                            />
                          </div>
                          <div className="col-4">
                            <FormControl
                              control="input"
                              label="Email"
                              name={`supplierAddresses[${index}].email`}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-3">
                            <FormControl
                              control="input"
                              label="PO Box"
                              name={`supplierAddresses[${index}].postBox`}
                            />
                          </div>
                          <div className="col-5">
                            <FormControl
                              control="input"
                              label="Country"
                              name={`supplierAddresses[${index}].country`}
                            />
                          </div>
                          <div className="col-4">
                            <FormControl
                              control="input"
                              label="City"
                              name={`supplierAddresses[${index}].city`}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <FormControl
                              control="input"
                              multiline
                              label="Address"
                              name={`supplierAddresses[${index}].address`}
                            />
                          </div>
                        </div>
                        <div className="row">
                          {code && (
                            <FormControl
                              control="switch"
                              label="Active"
                              name={`supplierAddresses[${index}].isActive`}
                            />
                          )}
                        </div>
                      </div>
                    ))}
                    <div className="row flex-end">
                      <IconButton
                        onClick={() =>
                          push({
                            firstName: "",
                            email: "",
                            secondName: "",
                            phone1: "",
                            phone2: "",
                            address: "",
                            country: "",
                            city: "",
                            postBox: "",
                            isActive: true,
                          })
                        }
                        color="primary"
                      >
                        <Add />
                      </IconButton>
                    </div>
                  </div>
                );
              }}
            </FieldArray>
          </>
        );

      default:
        return null;
    }
  }
};

export default AddSupplier;
